import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import { HttpStatus } from 'config/Api.Config';
import Icon from '../../components/icon/Icon';
import Page from '../../components/page/Page';

export default function ErrorPage(props: {
  status: Api.HttpStatus;
  message?: string;
  children?: Utils.ReactNodes;
  isLoading?: boolean;
}) {
  const { lang } = getLocales();
  return (
    <Page
      class={ThemePageError}
      isLoading={props.isLoading}
      sidebar={
        <Icon
          class={
            props.status === HttpStatus.unauthorized
              ? 'if-hand'
              : props.status === HttpStatus.notFound
                ? 'if-list'
                : props.status === HttpStatus.internalServerError
                  ? 'if-link-broken'
                  : props.status === HttpStatus.badRequest
                    ? 'if-question-circle'
                    : 'if-warning'
          }
        />
      }
      header={
        props.message || (
          <>
            {lang.error.toUpperCase()} <b>{props.status}</b>
          </>
        )
      }
      render={
        props.children
          ? props.children
          : props.status === HttpStatus.unauthorized
            ? lang.unauthorized.toUpperCase()
            : props.status === HttpStatus.notFound
              ? lang.notFound.toUpperCase()
              : props.status === HttpStatus.internalServerError
                ? lang.internalServerError.toUpperCase()
                : props.status === HttpStatus.badRequest
                  ? lang.badRequest.toUpperCase()
                  : lang.unknownError.toUpperCase()
      }
    />
  );
}
